// extracted by mini-css-extract-plugin
export default {"cardRow":"DynamicCardRow_cardRow__SyHI1","cardCol":"DynamicCardRow_cardCol__LUhHG"};